import { ChatMessage } from './chat';

export interface NotificationMessage {
  channel: string;
  data: NotificationMessagingDataPayload;
}

export enum NotificationMessagingType {
  GEMINI_RESPONSE = 'GEMINI_RESPONSE',
  GEMINI_RESPONSE_UPDATE = 'GEMINI_RESPONSE_UPDATE',
}

export interface NotificationMessageAiResponse {
  type:
    | NotificationMessagingType.GEMINI_RESPONSE
    | NotificationMessagingType.GEMINI_RESPONSE_UPDATE;
  chatId: string;
  message: ChatMessage;
}

export type NotificationMessagingDataPayload = NotificationMessageAiResponse;
